import t from 'tcomb';
import HText_Component from './HText_Component';
import Movie_Component from './Movie_Component';
import HTML_Component from './HTML_Component';
import Textbox_Component from './Textbox_Component';
import Select_Component from './Select_Component';
import Date_Component from './Date_Component';
import Like_Component from './Like_Component';
import Gplus_Component from './Gplus_Component';
import Checkboxes_Component from './Checkboxes_Component';
import Routing_Checkboxes_Component from './Routing_Checkboxes_Component';
import Field_Component from './Field_Component';
import Matrix_Component from './Matrix_Component';

export const Component = t.union([HText_Component, Movie_Component, Textbox_Component, Select_Component, Date_Component, Like_Component, Gplus_Component, Checkboxes_Component, Routing_Checkboxes_Component, Field_Component, Matrix_Component, HTML_Component], 'Component');

Component.map = {
  htext: HText_Component,
  movie: Movie_Component,
  textbox: Textbox_Component,
  select: Select_Component,
  date: Date_Component,
  like: Like_Component,
  checkboxes: Checkboxes_Component,
  routing_checkboxes: Routing_Checkboxes_Component,
  field: Field_Component,
  matrix: Matrix_Component,
  gplus: Gplus_Component,
  html: HTML_Component
};

Component.dispatch = (obj) => {
  return Component.map[obj.type];
};



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Component.js
 **/